import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import { CIRCUIT_PATH, ROUTE_PATH } from '../../../../config/paths';
import { clearRoute, getRoute, putRoute } from '../../../../actions';
import RouteForm from './RouteForm';
import { ROUTE_LENGTH_TYPE_OPTIONS } from '../../../../config/constants';

const EditRoute = ({
  breadcrumbs,
  dispatchClearRoute,
  dispatchGetRoute,
  dispatchPutRoute,
  match: {
    params: { id: routeId },
  },
  loading,
  route,
}) => {
  useLayoutEffect(() => {
    dispatchGetRoute({ routeId });
    return () => dispatchClearRoute();
  }, []);

  const onSubmit = (formValues) => {
    const originalRoute = route.toJS();

    const payload = {
      ...originalRoute,
      numberOfDrivers: formValues.numberOfDrivers,
      name: formValues.name,
      description: formValues.description,
      hotZone: formValues.hotZone ? formValues.hotZone : false,
      coldZone: formValues.coldZone ? formValues.coldZone : false,
      steepRoute: formValues.steepRoute ? formValues.steepRoute : false,
      flatRoute: formValues.flatRoute ? formValues.flatRoute : false,
      lengthType: formValues.lengthType.value,
      routeSegmentList: formValues.routeSegmentList.map(
        (originalSegment, index) => ({
          segmentId: originalSegment.segmentId.value,
          segmentOrder: index,
        }),
      ),
      isNorthChico: formValues.isNorthChico ? formValues.isNorthChico : false,
      // This is because routes that belong to North Chico must allow sales at authorized stops
      // Currently there is only one route, to facilitate the creation of new routes this logic is added
      isPostDepartSalesAllowed: formValues.isNorthChico ? formValues.isNorthChico : false,
    };

    dispatchPutRoute(routeId, payload);
  };

  const generateInitialValues = ({
    name,
    description,
    routeSegmentList,
    isOneWay,
    isMaciva,
    lengthType,
    numberOfDrivers,
    coldZone,
    hotZone,
    flatRoute,
    steepRoute,
    isNorthChico,
    active
  }) => ({
    name,
    description,
    isOneWay,
    isMaciva,
    numberOfDrivers,
    lengthType: {
      value: lengthType,
      label: ROUTE_LENGTH_TYPE_OPTIONS[lengthType].label,
    },
    routeSegmentList: routeSegmentList.map((routeSegment) => ({
      segmentId: {
        value: routeSegment.segmentId,
        label: `${routeSegment.segment.sourceLocation.name} - ${routeSegment.segment.destinationLocation.name}`,
      },
    })),
    coldZone,
    hotZone,
    flatRoute,
    steepRoute,
    isNorthChico,
    active
  });

  let content;

  if (loading) content = <Loader />;
  else if (route.isEmpty())
    content = <NoDataResource returnPage={CIRCUIT_PATH} />;
  else {
    content = (
      <RouteForm
        onSubmit={onSubmit}
        initialValues={generateInitialValues(route.toJS())}
        edit
      />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Editar Ruta"
      subtitle="Editar Ruta"
      content={content}
    />
  );
};

EditRoute.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearRoute: PropTypes.func.isRequired,
  dispatchGetRoute: PropTypes.func.isRequired,
  dispatchPutRoute: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  route: PropTypes.instanceOf(Immutable.Map).isRequired,
};

EditRoute.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearRoute: clearRoute,
  dispatchGetRoute: getRoute,
  dispatchPutRoute: putRoute,
};

const mapStateToProps = (
  { RouteUnit },
  {
    match: {
      params: { id },
    },
  },
) => ({
  breadcrumbs: [
    ...RouteUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Rutas',
      href: ROUTE_PATH,
    },
    {
      text: 'Ver',
      href: `${ROUTE_PATH}/${id}`,
    },
    {
      text: 'Editar',
      href: '',
    },
  ],
  route: RouteUnit.Route.getIn(['current', 'content']),
  loading: !RouteUnit.Route.getIn(['current', 'activity']).isEmpty(),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditRoute);
